export default __webpack_public_path__ + "static/media/noImage.6a775bd6.jpg";